import { render, staticRenderFns } from "./BatchLivePanel.vue?vue&type=template&id=5631e7ce"
import script from "./BatchLivePanel.vue?vue&type=script&lang=js"
export * from "./BatchLivePanel.vue?vue&type=script&lang=js"
import style0 from "./BatchLivePanel.vue?vue&type=style&index=0&id=5631e7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports